module.exports = __webpack_public_path__ + "img/38802-021.ab530915.jpg";